import { useState, useEffect } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  Stack,
  Pagination,
  Button,
  Paper,Dialog,
  DialogContent,
  IconButton,
  Divider,
} from "@mui/material";

import {
  AccessTimeOutlined,
  PlaceOutlined,
  ArrowForward,
  EventAvailableOutlined,
  CloseRounded,

} from "@mui/icons-material";

import { useAgendaPublica } from "../../hooks/UseAgenda";
import { obtenerFechaAgenda } from "../../utils/FechaAgenda";

export const AgendaComunicado = () => {

   const {
        agendas,
        loading,
        cargarAgendaPublica,
    } = useAgendaPublica();


    useEffect(() => {

        cargarAgendaPublica();

    }, []);

  const itemsPerPage = 8;

  const [page,setPage] = useState(1);

   const [actividadSeleccionada, setActividadSeleccionada] =
    useState(null);

  const totalPages = Math.ceil(agendas.length/itemsPerPage);

  const agendaPagina = agendas.slice(
    (page-1)*itemsPerPage,
    page*itemsPerPage
  );

  
  const handleOpenDialog = (item) => {
    setActividadSeleccionada(item);
  };

 
  const handleCloseDialog = () => {
    setActividadSeleccionada(null);
  };
  return (

    <Box py={8}>

      <Container maxWidth="xl" sx={{mt:{xs:6, sm:0}}}>
        <Paper sx={{
            position: "relative",
    borderRadius: "30px",
   p:{xs:0, md:3}
        }}>
        {/* Header */}

        <Stack
          direction="row"
          spacing={2}
          sx={{
            display:'flex', alignItems:'center', justifyContent:'start', mb:2
          }}
          
        >

          <Box
            sx={{
              width:58,
              height:58,
              borderRadius:"50%",
              bgcolor:"#fff",
              display:"flex",
              justifyContent:"center",
              alignItems:"center",
              boxShadow:"0 8px 20px rgba(0,0,0,.08)"
            }}
          >
            <EventAvailableOutlined
              sx={{
                color:"#484a75",
                fontSize:35
              }}
            />
          </Box>

          <Typography
            sx={{
              color:"#484a75",
              fontWeight:700,
              fontSize:{
                xs:"1rem",
                md:"1.3rem"
              }
            }}
          >
            Próximas actividades
          </Typography>

        </Stack>

        {/* Cards */}

        <Grid container  >

          {agendaPagina.map((item)=>(

            <Grid
              key={item.id}
              size={12}
              
            >

              <Card
                sx={{
                 
                  height:"100%",
                  transition:".3s",
                    
                  "&:hover":{
                    transform:"translateY(-8px)",
                    boxShadow:"0 18px 40px rgba(0,0,0,.12)"
                  }
                }}
              >

                <CardContent>

                  {/* Fecha */}
                    <Grid container spacing={1}  >
                        <Grid size={{xs:3, sm:2}}  >
                          
                              <Box
                    sx={{
                      width:60,
                      height:60,
                      borderRadius:"15px",
                      bgcolor:"#c69ba5a6",
                      color:"#561c33",
                      display:"flex",
                      flexDirection:"column",
                      justifyContent:"center",
                      alignItems:"center",
                    
                    }}
                  >

                    <Typography
                      sx={{
                        fontSize:{xs:'1.2rem', sm:"1.5rem"},
                        fontWeight:700,
                        lineHeight:1
                      }}
                    >
                       {obtenerFechaAgenda(item.fecha).dia}
                    </Typography>

                    <Typography sx={{
                        fontSize:{xs:'0.8rem', sm:"0.9rem"},
                        fontWeight:600,
                        lineHeight:1
                      }}>
                       {obtenerFechaAgenda(item.fecha).mes}
                    </Typography>

                  </Box>

                        </Grid>
                          <Grid  size={{xs:7, sm:8}}  >
                            <Box sx={{p:1}}>
                                
                                  <Typography
                    sx={{
                      fontWeight:700,
                      fontSize:{xs:'0.8rem', sm:"0.9rem"},
                      
                      mb:1,
                      color:"#2b2b2b",
                      lineHeight:1
                    }}
                  >
                    {item.titulo}
                  </Typography>

                  <Stack spacing={1} mb={1}>

                    <Stack direction="row" spacing={1} sx={{display:'flex', alignItems:'center', justifyContent:'left'}}>
                      <AccessTimeOutlined fontSize="small" />
                      <Typography  sx={{
                         fontSize:{xs:'0.75rem', sm:"0.9rem"},
                        fontWeight:500,
                        lineHeight:1
                      }}>{item.hora}</Typography>
                    </Stack>

                    <Stack direction="row" spacing={1}  sx={{display:'flex', alignItems:'center', justifyContent:'left'}}>
                      <PlaceOutlined fontSize="small"/>
                      <Typography  sx={{
                         fontSize:{xs:'0.75rem', sm:"0.9rem"},
                        fontWeight:500,
                        lineHeight:1
                      }}>{item.lugar}</Typography>
                    </Stack>

                  </Stack>
                            </Box>
                           
                          </Grid>
                            <Grid  size={{xs:2, sm:2}}  >
                                <Button
                                 onClick={() =>
                            handleOpenDialog(item)
                          }
  endIcon={<ArrowForward />}
  sx={{
    mt: 2,
    minWidth:  {xs:30,sm:46},
    width: {xs:30,sm:46},
    height: {xs:30,sm:46},
    p: 0,
    borderRadius: "50%",
    bgcolor: "#f3f4fb",
    border: "1px solid #484a75",
    color: "#484a75",
    transition: "all .3s ease",

    "& .MuiButton-endIcon": {
      margin: 0,
    },

    "&:hover": {
      bgcolor: "#484a75",
      color: "#fff",
      transform: "translateX(4px)",
      boxShadow: "0 8px 20px rgba(72,74,117,.20)",
    },
  }}
>
</Button>
                 
                
                            </Grid>
                    </Grid>
                
                

                 

                </CardContent>

              </Card>

            </Grid>

          ))}

        </Grid>

        <Box
          sx={{
            mt:5,
            display:"flex",
            justifyContent:"center"
          }}
        >
          <Pagination
            page={page}
            count={totalPages}
            onChange={(e,value)=>setPage(value)}
            shape="rounded"
            size="large"
          />
        </Box>
</Paper>
      </Container>
           <Dialog
        open={Boolean(actividadSeleccionada)}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="md"
        scroll="paper"
        PaperProps={{
          sx: {
            borderRadius: {
              xs: "18px",
              sm: "25px",
            },
            overflow: "hidden",
            width: {
              xs: "calc(100% - 24px)",
              sm: "90%",
            },
            maxHeight: {
              xs: "90vh",
              md: "85vh",
            },
          },
        }}
      >

        {actividadSeleccionada && (

          <>

            {/* CABECERA */}

            <Box
              sx={{
                position: "relative",
                bgcolor: "#484a75",
                color: "#fff",
                px: {
                  xs: 3,
                  sm: 5,
                },
                py: {
                  xs: 3,
                  sm: 4,
                },
              }}
            >

              <IconButton
                onClick={handleCloseDialog}
                sx={{
                  position: "absolute",
                  right: {
                    xs: 10,
                    sm: 16,
                  },
                  top: {
                    xs: 10,
                    sm: 16,
                  },
                  color: "#fff",
                  bgcolor:
                    "rgba(255,255,255,.12)",

                  "&:hover": {
                    bgcolor:
                      "rgba(255,255,255,.22)",
                  },
                }}
              >
                <CloseRounded />
              </IconButton>

              <Typography
                sx={{
                  fontSize: {
                    xs: "0.75rem",
                    sm: "0.85rem",
                  },
                  fontWeight: 600,
                  opacity: 0.8,
                  mb: 1,
                  textTransform: "uppercase",
                }}
              >
                Agenda escolar
              </Typography>

              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: {
                    xs: "1.4rem",
                    sm: "2rem",
                    md: "2.3rem",
                  },
                  lineHeight: 1.2,
                  pr: 4,
                }}
              >
                {actividadSeleccionada.titulo}
              </Typography>

            </Box>

            {/* CONTENIDO */}

            <DialogContent
              sx={{
                p: {
                  xs: 3,
                  sm: 5,
                },
              }}
            >

              {/* FECHA DESTACADA */}

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  mb: 4,
                  p: {
                    xs: 2,
                    sm: 3,
                  },
                  bgcolor: "#f5f6fb",
                  borderRadius: "18px",
                }}
              >

                <Box
                  sx={{
                    width: {
                      xs: 65,
                      sm: 75,
                    },
                    height: {
                      xs: 65,
                      sm: 75,
                    },
                    flexShrink: 0,
                    borderRadius: "16px",
                    bgcolor: "#c69ba5a6",
                    color: "#561c33",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >

                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: {
                        xs: "1.4rem",
                        sm: "1.7rem",
                      },
                      lineHeight: 1,
                    }}
                  > {obtenerFechaAgenda(actividadSeleccionada.fecha).dia}
                   
                  </Typography>

                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "0.85rem",
                    }}
                  >
                    {obtenerFechaAgenda(actividadSeleccionada.fecha).mes}
               
                  </Typography>

                </Box>

                <Box>

                  <Typography
                    sx={{
                      color: "#777",
                      fontSize: {
                        xs: "0.8rem",
                        sm: "0.9rem",
                      },
                    }}
                  >
                    Fecha de la actividad
                  </Typography>

                  <Typography
                    sx={{
                      color: "#484a75",
                      fontWeight: 700,
                      fontSize: {
                        xs: "0.95rem",
                        sm: "1.1rem",
                      },
                    }}
                  >
                    {actividadSeleccionada.fechaCompleta}
                  </Typography>

                </Box>

              </Box>

              <Divider sx={{ mb: 4 }} />

              {/* DATOS */}

              <Grid
                container
                spacing={2}
                mb={4}
              >

                <Grid
                  size={{
                    xs: 12,
                    sm: 6,
                  }}
                >

                  <Box
                    sx={{
                      p: 2.5,
                      height: "100%",
                      borderRadius: "16px",
                      bgcolor: "#fafafa",
                      border:
                        "1px solid #eeeeee",
                    }}
                  >

                    <Stack
                      direction="row"
                      spacing={1.5}
                      alignItems="center"
                    >

                      <AccessTimeOutlined
                        sx={{
                          color: "#484a75",
                        }}
                      />

                      <Box>

                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            color: "#888",
                          }}
                        >
                          Horario
                        </Typography>

                        <Typography
                          fontWeight={700}
                          color="#333"
                        >
                          {actividadSeleccionada.hora}
                        </Typography>

                      </Box>

                    </Stack>

                  </Box>

                </Grid>

                <Grid
                  size={{
                    xs: 12,
                    sm: 6,
                  }}
                >

                  <Box
                    sx={{
                      p: 2.5,
                      height: "100%",
                      borderRadius: "16px",
                      bgcolor: "#fafafa",
                      border:
                        "1px solid #eeeeee",
                    }}
                  >

                    <Stack
                      direction="row"
                      spacing={1.5}
                      alignItems="center"
                    >

                      <PlaceOutlined
                        sx={{
                          color: "#484a75",
                        }}
                      />

                      <Box>

                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            color: "#888",
                          }}
                        >
                          Lugar
                        </Typography>

                        <Typography
                          fontWeight={700}
                          color="#333"
                        >
                          {actividadSeleccionada.lugar}
                        </Typography>

                      </Box>

                    </Stack>

                  </Box>

                </Grid>

              </Grid>

              {/* DESCRIPCIÓN */}

              <Typography
                sx={{mt:5,
                  color: "#484a75",
                  fontWeight: 700,
                  fontSize: {
                    xs: "1rem",
                    sm: "1.15rem",
                  },
                  mb: 1.5,
                }}
              >
                Información de la actividad
              </Typography>

              <Typography
                sx={{
                  color: "#666",
                  lineHeight: 1.8,
                  fontSize: {
                    xs: "0.9rem",
                    sm: "1rem",
                  },
                }}
              >
                {actividadSeleccionada.descripcion}
              </Typography>

            </DialogContent>

          </>

        )}

      </Dialog>

    </Box>

  );
};